import { put, SagaGenerator, select, takeEvery } from "typed-redux-saga";

import { ActivityActions, ActivityMap, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { ApplicationModel, ModelSelectors } from "@com.mgmtp.a12.client/client-core/lib/core/model";

import { getViewHtmlId } from "../../modules/focusHandling/sagas";

import { handleEscape } from "../actions";

import MatchCondition = ApplicationModel.MatchCondition;

/**
 * Reagiert auf das "handleEscape"-Event, was beim Drücken der Escape-Taste ausgelöst wird (index.tsx).
 * Schließt ein eventuell geöffnetes Modal:
 * Falls eine Aktivität geöffnet ist, der eine Szene aus dem Appmodel zugeordnet werden kann, welche in der
 * Region "MODAL" angezeigt wird, wird das Canceln dieser Aktivität angefragt.
 */
export function* handleEscapeSaga(): SagaGenerator<void> {
	yield* takeEvery(handleEscape, handleEscapeWorker);
}

function* handleEscapeWorker(): SagaGenerator<void> {
	const activityMap = yield* select(ActivitySelectors.activities());
	const activities = ActivityMap.toList(activityMap);
	const appModel = yield* select(ModelSelectors.applicationModel());

	const scenes = appModel.content.modules.flatMap(module => module.flows).flatMap(it => it.scenes);

	for (const activity of activities) {
		const scene = scenes.find(it =>
			it.matchConditions.every(condition => MatchCondition.evaluate(condition, activity.descriptor))
		);
		if (!scene?.sceneChange) {
			continue;
		}

		const isModal = (scene.sceneChange.onEnter ?? []).find(it => (it.region ?? []).includes("MODAL"));
		if (isModal) {
			const id = getViewHtmlId(activity.initiatingActivityId);
			const element = id ? document.getElementById(id) : null;

			element?.focus();

			// Cancel this activity
			yield* put(ActivityActions.cancelRequested({ activityIds: [activity.id] }));
			return;
		}
	}
}
